// extracted by mini-css-extract-plugin
export default {"box_wrap":"style_box_wrap__AVufK","box":"style_box__3GbrX","list_item":"style_list_item__P7WA7","is_select":"style_is_select__toGM5"};